module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "chapter"
    }
  }, [_c('p', {
    staticClass: "h1",
    staticStyle: {
      "color": "#82a339"
    },
    attrs: {
      "id": "d7e2227864"
    }
  }, [_c('b', [_vm._v("MINESTRONE WITH PESTO")])]), _vm._v(" "), _c('p', {
    staticClass: "ext",
    attrs: {
      "id": "d7e2228364"
    }
  }, [_c('b', [_c('i', [_vm._v("Freshly made pesto adds body and richness to this soup. During the summer, when basil is plentiful and well priced, make up a double or triple batch of our homemade pesto. Pack it into a jar, top it off with a thin layer of olive oil to keep it nice and green, then put the lid on. Refrigerate for up to several months.")])])]), _vm._v(" "), _c('p', {
    staticClass: "h4",
    staticStyle: {
      "color": "#496210"
    },
    attrs: {
      "id": "d7e2231064"
    }
  }, [_c('b', [_vm._v("Prep: 20 minutes plus soaking beans Cook: 1 hour")])]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e2231564"
    }
  }, [_vm._v("8 ounces dry Great Northern beans (1⅓ cups), "), _c('br'), _vm._v(" soaked and drained")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e2233264"
    }
  }, [_vm._v("2 tablespoons olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e2233564"
    }
  }, [_vm._v("3 carrots, peeled and cut into ¼-inch-thick slices")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e2234764"
    }
  }, [_vm._v("2 stalks celery, cut into ¼-inch-thick slices")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e2235964"
    }
  }, [_vm._v("1 large onion (12 ounces), finely chopped")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e2236264"
    }
  }, [_vm._v("2 ounces pancetta or bacon, finely chopped")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e2236864"
    }
  }, [_vm._v("1 pound all-purpose potatoes (3 medium), peeled "), _c('br'), _vm._v(" and chopped")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e2237464"
    }
  }, [_vm._v("2 medium zucchini (8 ounces each), each cut "), _c('br'), _vm._v(" lengthwise into quarters, then crosswise into "), _c('br'), _vm._v("¼-inch-thick slices")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e2239064"
    }
  }, [_vm._v("½ medium head savoy cabbage (1 pound), "), _c('br'), _vm._v(" thinly sliced")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e2240364"
    }
  }, [_vm._v("1 large garlic clove, crushed with garlic press")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e2240664"
    }
  }, [_vm._v("1 can (14½ ounces) diced tomatoes")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e2241764"
    }
  }, [_vm._v("2 cans (14½ ounces each) chicken broth or 3½ cups Chicken Broth")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e2244164"
    }
  }, [_vm._v("1 cup water "), _c('br'), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/West_9781618371621_epub_c66_r1#d7e2258264"
    }
  }, [_vm._v("Pesto")]), _vm._v(" or ½ cup store-bought pesto")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e2245864"
    }
  }, [_vm._v("½ teaspoon salt")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    staticStyle: {
      "margin-top": "1.5em"
    },
    attrs: {
      "id": "d7e2247064"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#c15b49"
    }
  }, [_c('b', [_vm._v("1.")])]), _vm._v(" In 4-quart saucepan, combine beans and enough "), _c('i', [_vm._v("water to cover by 2 inches; ")]), _vm._v("heat to boiling over high heat. Reduce heat; cover and simmer, stirring occasionally, until beans are tender, 40 minutes to 1 hour. Drain beans.")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e2249664"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#c15b49"
    }
  }, [_c('b', [_vm._v("2.")])]), _vm._v(" Meanwhile, in nonreactive 5-quart Dutch oven, heat oil over medium-high heat. Add carrots, celery, onion, and pancetta; cook, stirring occasionally, until onions begin to brown, about 10 minutes. Add potatoes, zucchini, cabbage, and garlic; cook, stirring constantly, until cabbage has wilted. Add tomatoes with their juice, broth, and water; heat to boiling over high heat. Reduce heat; cover and simmer until vegetables are tender, about 30 minutes.")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e2253964"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#c15b49"
    }
  }, [_c('b', [_vm._v("3.")])]), _vm._v(" Meanwhile, prepare pesto.")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e2254964"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#c15b49"
    }
  }, [_c('b', [_vm._v("4.")])]), _vm._v(" In blender or in food processor with knife blade attached, puree ½ cup beans with 1 cup soup mixture until smooth. Stir puree, remaining beans, and salt into soup; heat to boiling. Reduce heat; cover and simmer 10 minutes. Garnish with dollops of pesto. Makes about 13 cups or 6 main-dish servings.")]), _vm._v(" "), _c('p', {
    staticClass: "h4l",
    staticStyle: {
      "color": "#496210"
    },
    attrs: {
      "id": "d7e2258264"
    }
  }, [_c('b', [_vm._v("PESTO")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e2258764"
    }
  }, [_vm._v("In blender, puree "), _c('b', [_vm._v("⅔ cup packed fresh basil leaves, ¼ cup freshly grated Parmesan cheese, ¼ cup olive oil, 1 tablespoon water,")]), _vm._v(" and "), _c('b', [_vm._v("¼ teaspoon salt")]), _vm._v(" until smooth.")]), _vm._v(" "), _c('p', {
    staticClass: "ntx",
    attrs: {
      "id": "d7e2263964"
    }
  }, [_vm._v("Each serving with pesto: About 444 calories, 18g protein, 53g carbohydrate, 20g total fat (4g saturated), 9mg cholesterol, 1,204mg sodium.")]), _vm._v(" "), _c('p', {
    staticClass: "h4l",
    staticStyle: {
      "color": "#496210"
    },
    attrs: {
      "id": "d7e2266864"
    }
  }, [_c('b', [_vm._v("QUICK MINESTRONE")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e2267364"
    }
  }, [_vm._v("Prepare as directed omitting Step 1 and use "), _c('b', [_vm._v("2 cans (15 to 19 ounces each) Great Northern beans,")]), _vm._v(" rinsed and drained, for soaked beans. Add beans with tomatoes.")]), _vm._v(" "), _c('div', {
    staticClass: "side"
  }, [_c('p', {
    staticClass: "sidebarh3",
    staticStyle: {
      "color": "#8A4117"
    },
    attrs: {
      "id": "d7e2269164"
    }
  }, [_c('b', [_vm._v("SOUP SAVVY")])]), _vm._v(" "), _c('p', {
    staticClass: "sidebartx1",
    attrs: {
      "id": "d7e2269664"
    }
  }, [_vm._v("Here are some of the most popular types of soups:")]), _vm._v(" "), _c('p', {
    staticClass: "sidebartx1",
    attrs: {
      "id": "d7e2270164"
    }
  }, [_c('b', [_vm._v("BISQUE:")]), _vm._v(" A classic French soup with a rich, creamy texture. It is usually made from shellfish and thickened with rice.")]), _vm._v(" "), _c('p', {
    staticClass: "sidebartx1",
    attrs: {
      "id": "d7e2271964"
    }
  }, [_c('b', [_vm._v("BROTH:")]), _vm._v(" A flavorful liquid made from simmered meat, fish, or poultry and/or vegetables.")]), _vm._v(" "), _c('p', {
    staticClass: "sidebartx1",
    attrs: {
      "id": "d7e2273464"
    }
  }, [_c('b', [_vm._v("CHOWDER:")]), _vm._v(" Hearty and chunky, this soup is chockfull of fish, shellfish, and/or vegetables. Clam chowder has been popular in New England since colonial times.")]), _vm._v(" "), _c('p', {
    staticClass: "sidebartx1",
    attrs: {
      "id": "d7e2275464"
    }
  }, [_c('b', [_vm._v("CONSOMMÉ :")]), _vm._v(" Broth that has been clarified into a crystal-clear liquid.")]), _vm._v(" "), _c('p', {
    staticClass: "sidebartx1",
    attrs: {
      "id": "d7e2277064"
    }
  }, [_c('b', [_vm._v("GUMBO:")]), _vm._v(" One of the signature dishes of Cajun cooking, gumbo is a thick soup that can contain chicken, duck, seafood, or ham and vegetables such as tomatoes, onion, bell peppers, and celery. It is thickened with a roux (a browned butter and flour mixture), okra, and/or filé (ground sassafras leaves) and is served over white rice.")]), _vm._v(" "), _c('p', {
    staticClass: "sidebartx1",
    attrs: {
      "id": "d7e2281164"
    }
  }, [_c('b', [_vm._v("STOCK:")]), _vm._v(" Similar to broth but made from bones, often roasted, that are simmered with water and/or vegetables.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-de3a197e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/West_9781618371621_epub_c66_r1.vue
// module id = 264
// module chunks = 0